/**
 * /settings — settings landing. Sections: Categories, Tags, Household, Account.
 */
import { Link } from 'react-router-dom';
import { CaretRight } from '@phosphor-icons/react';
import { PageHeader } from '../../components/ui/PageHeader';

const ROWS = [
  {
    to: '/settings/categories',
    label: 'Categories',
    hint: 'Restaurants, hotels, services — or your own',
  },
  {
    to: '/settings/tags',
    label: 'Tags',
    hint: 'Optional labels for places',
  },
  {
    to: '/settings/household',
    label: 'Household',
    hint: 'Members, invites, name',
  },
  {
    to: '/settings/account',
    label: 'Account',
    hint: 'Email, display name, sign out',
  },
];

export default function SettingsRoute() {
  return (
    <>
      <PageHeader
        eyebrow="Settings"
        title="What you keep, where."
        description="A few small things to tune your journal."
      />
      <ul className="divide-y divide-ink-100 border-y border-ink-200">
        {ROWS.map((r) => (
          <li key={r.to}>
            <Link
              to={r.to}
              className="flex items-center justify-between py-5 px-1 hover:bg-surface-2 transition-colors duration-200 ease-out-slow focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-accent"
            >
              <div>
                <p className="font-serif text-lg text-ink-900">{r.label}</p>
                <p className="mt-0.5 text-xs text-ink-500">{r.hint}</p>
              </div>
              <CaretRight size={16} weight="regular" className="text-ink-400" aria-hidden />
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
